import React from 'react';
import BaseCell from './BaseCell';
import { applyPhoneMask } from 'shared/../helpers/formatting';

const PhoneNumberCell = ({ phoneNumber: rawValue, applyMask = false, ...props }) => {
  const phoneNumber = applyMask ? applyPhoneMask(rawValue) : rawValue;

  return (
    <BaseCell {...props} selectable={false}>
      <a href={`tel:${phoneNumber}`}>{phoneNumber}</a>
    </BaseCell>
  );
};

export default PhoneNumberCell;
